import { Button } from "@volca/ui/components/ui/button";
import { GAS_METER, WATER_HEATER } from "@volca/ui/components/ui/empty-machine";
import { MachineEmptyState } from "@volca/ui/components/ui/machine-empty-state";
import { Stack } from "@volca/ui/components/ui/stack";
import type { EmptyActions } from "@/profitability/template-page/use-empty-actions";
import type { ProfitabilityReport } from "@/profitability/types";

/**
 * The Review before the agent has a report: its first period building,
 * the agent still being set up, or published and never run. Each offers
 * the step that gets there, to whoever may take it.
 */
export const OverviewStart = ({
  report,
  building,
  actions,
}: {
  report: ProfitabilityReport;
  /** The first period is running. */
  building: boolean;
  actions: EmptyActions;
}) => {
  if (building)
    return (
      <Stack role="status" align="stretch" className="w-full flex-1">
        <MachineEmptyState
          art={WATER_HEATER}
          layout="workspace"
          active
          title="The first report is building"
          description="Volca is reading your documents and running the numbers. You can leave this page. The report keeps building."
        >
          {actions.progress && (
            <Button variant="secondary" onClick={actions.progress}>
              See progress
            </Button>
          )}
        </MachineEmptyState>
      </Stack>
    );
  if (!report.published)
    return (
      <MachineEmptyState
        art={GAS_METER}
        layout="workspace"
        title="Reviews start once this agent runs"
        description="This agent is still being set up. Once it runs a week, the jobs it flags show up here to review."
      />
    );
  return (
    <MachineEmptyState
      art={GAS_METER}
      layout="workspace"
      title="No reports yet"
      description={
        actions.run
          ? "Run a period and its results will show up here."
          : "Results show up here once someone who manages this agent runs a period."
      }
    >
      {actions.run && <Button onClick={actions.run}>Run a period</Button>}
    </MachineEmptyState>
  );
};
